import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SmsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Sms",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M27.2 2.93H14.13c-1.54 0-2.79 1.25-2.8 2.8v2.8h8.4c2.57 0 4.66 2.09 4.66 4.66v2.8h2.8c1.54 0 2.79-1.25 2.8-2.8V5.73c0-1.54-1.25-2.79-2.8-2.8ZM2.57 29a.93.93 0 0 0 1.02-.21l5.33-5.33h10.81c1.54 0 2.79-1.25 2.8-2.8V13.2c0-1.54-1.25-2.79-2.8-2.8H4.8c-1.54 0-2.79 1.25-2.8 2.8v14.93c0 .39.23.72.57.86Zm3.16-14.86H18.8c.52 0 .93.42.93.93s-.42.93-.93.93H5.73c-.52 0-.93-.42-.93-.93s.42-.93.93-.93m0 3.73H18.8c.52 0 .93.42.93.93s-.42.93-.93.93H5.73c-.52 0-.93-.42-.93-.93s.42-.93.93-.93"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M16.71 13.29H7.57a1.14 1.14 0 1 1 0-2.28h9.14a1.14 1.14 0 1 1 0 2.28M13.29 17.86H7.58a1.14 1.14 0 1 1 0-2.28h5.71a1.14 1.14 0 1 1 0 2.28M29.29 17.86c-.63 0-1.14-.51-1.14-1.14V5.29c0-.63-.51-1.14-1.14-1.14H9.86a1.14 1.14 0 1 1 0-2.28H27c1.89 0 3.43 1.54 3.43 3.43v11.43c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M3 30.43c-.15 0-.3-.03-.44-.09-.43-.18-.71-.59-.71-1.06V9.86c0-1.89 1.54-3.43 3.43-3.43h17.14c1.89 0 3.43 1.54 3.43 3.43v11.43c0 1.89-1.54 3.43-3.43 3.43H9.18L3.8 30.1c-.22.22-.51.33-.81.33ZM5.29 8.71c-.63 0-1.14.51-1.14 1.14v16.67l3.76-3.76c.21-.21.51-.33.81-.33h13.71c.63 0 1.14-.51 1.14-1.14V9.86c0-.63-.51-1.14-1.14-1.14H5.29Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M29.29 17.86c-.63 0-1.14-.51-1.14-1.14V5.29c0-.63-.51-1.14-1.14-1.14H9.86a1.14 1.14 0 1 1 0-2.28H27c1.89 0 3.43 1.54 3.43 3.43v11.43c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M3 30.43c-.15 0-.3-.03-.44-.09-.43-.18-.71-.59-.71-1.06V9.86c0-1.89 1.54-3.43 3.43-3.43h17.14c1.89 0 3.43 1.54 3.43 3.43v11.43c0 1.89-1.54 3.43-3.43 3.43H9.18L3.8 30.1c-.22.22-.51.33-.81.33ZM5.29 8.71c-.63 0-1.14.51-1.14 1.14v16.67l3.76-3.76c.21-.21.51-.33.81-.33h13.71c.63 0 1.14-.51 1.14-1.14V9.86c0-.63-.51-1.14-1.14-1.14H5.29Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M29.29 17.86c-.63 0-1.14-.51-1.14-1.14V5.29c0-.63-.51-1.14-1.14-1.14H9.86a1.14 1.14 0 1 1 0-2.28H27c1.89 0 3.43 1.54 3.43 3.43v11.43c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M3 30.43c-.15 0-.3-.03-.44-.09-.43-.18-.71-.59-.71-1.06V9.86c0-1.89 1.54-3.43 3.43-3.43h17.14c1.89 0 3.43 1.54 3.43 3.43v11.43c0 1.89-1.54 3.43-3.43 3.43H9.18L3.8 30.1c-.22.22-.51.33-.81.33ZM5.29 8.71c-.63 0-1.14.51-1.14 1.14v16.67l3.76-3.76c.21-.21.51-.33.81-.33h13.71c.63 0 1.14-.51 1.14-1.14V9.86c0-.63-.51-1.14-1.14-1.14H5.29Z"
      })]
    })
  }));
};
SmsIcon.displayName = 'SmsIcon';